import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'
import { authApi } from 'shared/api/auth'

import { CheckTokenRequest, CheckTokenResponse } from './checkToken.types'

export const checkToken = async (request: CheckTokenRequest) => {
  const response = await authApi.get<CheckTokenResponse>('/checkToken', {
    headers: {
      Authorization: `Bearer ${request.token}`
    }
  })
  return response.data
}

export const CHECK_TOKEN_QUERY_KEY = 'checkToken'

export const useCheckTokenQuery = (
  args: CheckTokenRequest,
  options?: ExtendableQueryOptions<CheckTokenResponse>
) => {
  return useQuery({
    queryKey: [CHECK_TOKEN_QUERY_KEY, args.token, ...(options?.queryKey || [])],
    queryFn: () => {
      return checkToken(args)
    },
    enabled: !!args.token,
    ...options
  })
}
